export const REQUESTING_CLIENT = 'applications-renter-web';
